/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Col, FormText, Row } from 'reactstrap';
import { Translate, ValidatedField, ValidatedForm, isNumber, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities as getContactDetails } from 'app/entities/contact-details/contact-details.reducer';
import { getUsers } from 'app/shared/reducers/user-management';
import { createEntity, getEntity, reset, updateEntity } from './gluco-user.reducer';

export const GlucoUserUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const contactDetails = useAppSelector(state => state.contactDetails.entities);
  const users = useAppSelector(state => state.userManagement.users);
  const glucoUserEntity = useAppSelector(state => state.glucoUser.entity);
  const loading = useAppSelector(state => state.glucoUser.loading);
  const updating = useAppSelector(state => state.glucoUser.updating);
  const updateSuccess = useAppSelector(state => state.glucoUser.updateSuccess);

  const handleClose = () => {
    navigate(`/gluco-user${location.search}`);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }

    dispatch(getContactDetails({}));
    dispatch(getUsers({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    if (values.age !== undefined && typeof values.age !== 'number') {
      values.age = Number(values.age);
    }
    if (values.customRangeMax !== undefined && typeof values.customRangeMax !== 'number') {
      values.customRangeMax = Number(values.customRangeMax);
    }
    if (values.customRangeMin !== undefined && typeof values.customRangeMin !== 'number') {
      values.customRangeMin = Number(values.customRangeMin);
    }
    if (values.height !== undefined && typeof values.height !== 'number') {
      values.height = Number(values.height);
    }
    if (values.microSec !== undefined && typeof values.microSec !== 'number') {
      values.microSec = Number(values.microSec);
    }
    if (values.timestampentry !== undefined && typeof values.timestampentry !== 'number') {
      values.timestampentry = Number(values.timestampentry);
    }
    if (values.dateOfBirth !== undefined && typeof values.dateOfBirth !== 'number') {
      values.dateOfBirth = Number(values.dateOfBirth);
    }
    if (values.lastupdated !== undefined && typeof values.lastupdated !== 'number') {
      values.lastupdated = Number(values.lastupdated);
    }
    if (values.cursor !== undefined && typeof values.cursor !== 'number') {
      values.cursor = Number(values.cursor);
    }
    if (values.deceasedDate !== undefined && typeof values.deceasedDate !== 'number') {
      values.deceasedDate = Number(values.deceasedDate);
    }

    const entity = {
      ...glucoUserEntity,
      ...values,
      contactDetails: contactDetails.find(it => it.id.toString() === values.contactDetails?.toString()),
      tmUser: users.find(it => it.id.toString() === values.tmUser?.toString()),
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          ...glucoUserEntity,
          contactDetails: glucoUserEntity?.contactDetails?.id,
          tmUser: glucoUserEntity?.tmUser?.id,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="tinyMedicRestApp.glucoUser.home.createOrEditLabel" data-cy="GlucoUserCreateUpdateHeading">
            <Translate contentKey="tinyMedicRestApp.glucoUser.home.createOrEditLabel">Create or edit a GlucoUser</Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="gluco-user-id"
                  label={translate('tinyMedicRestApp.glucoUser.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('tinyMedicRestApp.glucoUser.active')}
                id="gluco-user-active"
                name="active"
                data-cy="active"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.glucoUser.age')}
                id="gluco-user-age"
                name="age"
                data-cy="age"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.glucoUser.country')}
                id="gluco-user-country"
                name="country"
                data-cy="country"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  maxLength: { value: 255, message: translate('entity.validation.maxlength', { max: 255 }) },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.glucoUser.customRangeMax')}
                id="gluco-user-customRangeMax"
                name="customRangeMax"
                data-cy="customRangeMax"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.glucoUser.customRangeMin')}
                id="gluco-user-customRangeMin"
                name="customRangeMin"
                data-cy="customRangeMin"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.glucoUser.typeOfDiabeties')}
                id="gluco-user-typeOfDiabeties"
                name="typeOfDiabeties"
                data-cy="typeOfDiabeties"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  maxLength: { value: 50, message: translate('entity.validation.maxlength', { max: 50 }) },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.glucoUser.gender')}
                id="gluco-user-gender"
                name="gender"
                data-cy="gender"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  maxLength: { value: 50, message: translate('entity.validation.maxlength', { max: 50 }) },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.glucoUser.height')}
                id="gluco-user-height"
                name="height"
                data-cy="height"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.glucoUser.microSec')}
                id="gluco-user-microSec"
                name="microSec"
                data-cy="microSec"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.glucoUser.mobile')}
                id="gluco-user-mobile"
                name="mobile"
                data-cy="mobile"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  maxLength: { value: 255, message: translate('entity.validation.maxlength', { max: 255 }) },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.glucoUser.name')}
                id="gluco-user-name"
                name="name"
                data-cy="name"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  maxLength: { value: 255, message: translate('entity.validation.maxlength', { max: 255 }) },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.glucoUser.tmPassword')}
                id="gluco-user-tmPassword"
                name="tmPassword"
                data-cy="tmPassword"
                type="text"
                validate={{
                  maxLength: { value: 255, message: translate('entity.validation.maxlength', { max: 255 }) },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.glucoUser.preferredGlucoseUnit')}
                id="gluco-user-preferredGlucoseUnit"
                name="preferredGlucoseUnit"
                data-cy="preferredGlucoseUnit"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  maxLength: { value: 50, message: translate('entity.validation.maxlength', { max: 50 }) },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.glucoUser.preferredLanguage')}
                id="gluco-user-preferredLanguage"
                name="preferredLanguage"
                data-cy="preferredLanguage"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  maxLength: { value: 255, message: translate('entity.validation.maxlength', { max: 255 }) },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.glucoUser.preferredRange')}
                id="gluco-user-preferredRange"
                name="preferredRange"
                data-cy="preferredRange"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  maxLength: { value: 50, message: translate('entity.validation.maxlength', { max: 50 }) },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.glucoUser.preferredUnitA1c')}
                id="gluco-user-preferredUnitA1c"
                name="preferredUnitA1c"
                data-cy="preferredUnitA1c"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  maxLength: { value: 50, message: translate('entity.validation.maxlength', { max: 50 }) },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.glucoUser.preferredUnitWeight')}
                id="gluco-user-preferredUnitWeight"
                name="preferredUnitWeight"
                data-cy="preferredUnitWeight"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  maxLength: { value: 50, message: translate('entity.validation.maxlength', { max: 50 }) },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.glucoUser.timestampentry')}
                id="gluco-user-timestampentry"
                name="timestampentry"
                data-cy="timestampentry"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.glucoUser.parent')}
                id="gluco-user-parent"
                name="parent"
                data-cy="parent"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.glucoUser.dateOfBirth')}
                id="gluco-user-dateOfBirth"
                name="dateOfBirth"
                data-cy="dateOfBirth"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.glucoUser.uuid')}
                id="gluco-user-uuid"
                name="uuid"
                data-cy="uuid"
                type="text"
                validate={{
                  maxLength: { value: 256, message: translate('entity.validation.maxlength', { max: 256 }) },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.glucoUser.bloodGroup')}
                id="gluco-user-bloodGroup"
                name="bloodGroup"
                data-cy="bloodGroup"
                type="text"
                validate={{
                  maxLength: { value: 50, message: translate('entity.validation.maxlength', { max: 50 }) },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.glucoUser.lastupdated')}
                id="gluco-user-lastupdated"
                name="lastupdated"
                data-cy="lastupdated"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.glucoUser.cursor')}
                id="gluco-user-cursor"
                name="cursor"
                data-cy="cursor"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.glucoUser.imported')}
                id="gluco-user-imported"
                name="imported"
                data-cy="imported"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.glucoUser.deceased')}
                id="gluco-user-deceased"
                name="deceased"
                data-cy="deceased"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.glucoUser.deceasedDate')}
                id="gluco-user-deceasedDate"
                name="deceasedDate"
                data-cy="deceasedDate"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.glucoUser.deceasedReason')}
                id="gluco-user-deceasedReason"
                name="deceasedReason"
                data-cy="deceasedReason"
                type="text"
              />
              <ValidatedField
                id="gluco-user-contactDetails"
                name="contactDetails"
                data-cy="contactDetails"
                label={translate('tinyMedicRestApp.glucoUser.contactDetails')}
                type="select"
              >
                <option value="" key="0" />
                {contactDetails
                  ? contactDetails.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="gluco-user-tmUser"
                name="tmUser"
                data-cy="tmUser"
                label={translate('tinyMedicRestApp.glucoUser.tmUser')}
                type="select"
                required
              >
                <option value="" key="0" />
                {users
                  ? users.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <FormText>
                <Translate contentKey="entity.validation.required">This field is required.</Translate>
              </FormText>
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/gluco-user" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default GlucoUserUpdate;
